import request from '@/utils/request'

export function getDeptList(data) {
  return request.post('/dept/list', data)
}

export function getEmployeeList(data) {
  return request.post('/employee/list', data)
}

export function addEmployee(data) {
  return request.post('/employee/add', data)
}

export function modifyEmployee(data) {
  return request.post('/employee/modify', data)
}

export function setOnTheJobOfEmployee(data) {
  return request.post('/employee/on-the-job', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/employee.js